export default __webpack_public_path__ + "static/media/_domain_4.b5874a19.png";